import { usePlmId } from './PgmUtilities';
import { useIsPgm } from '../stores/EnvironmentStore';

export function useIsGlobal() {
    const plmId = usePlmId();
    const [isPgm] = useIsPgm();
    return isPgm && !plmId;
}

export function useIsSelf() {
    const plmId = usePlmId();
    const [isPgm] = useIsPgm();
    return isPgm || !plmId;
}
